import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from '../AppContext';
import { UpdateUserFullNameInput, UpdateUserFullNamePayload } from './generated/types';

const mutation = `mutation MyMutation($input: UpdateUserFullNameInput!) {
    updateUserFullName(input: $input) {
        succeeded
    }
}
`;

export const useUpdateUserName = (userId: string, onSuccessHandler: () => void) => {
    const context = useContext(AppContext);

    return useMutation({
        mutationFn: async (params: Omit<UpdateUserFullNameInput, 'id'>) => {

            const input: UpdateUserFullNameInput = {
                id: userId,
                ...params,
            };

            await (context.api.graphql({
                query: mutation,
                variables: { input },
            }) as Promise<{
                data: {
                    updateUserFullName: UpdateUserFullNamePayload;
                };
            }>);
        },
        onSuccess: () => { onSuccessHandler(); },
    },
    );
};